import { Button } from "antd";
import Shape1 from "../../../assets/web/images/shape-1.svg";
import Shape2 from "../../../assets/web/images/shape-2.svg";
import Shape3 from "../../../assets/web/images/shape-3.svg";
import BannerContainer from "../common/BannerContainer";
import PrimaryButton from "../PrimaryButton";

const Banner = () => {
  return (
    <BannerContainer>
      <div className="text-4xl md:text-6xl font-bold text-center text-textHeading">
        <span className="md:block">
          <span className="relative">
            <span className="">One</span>
            <img src={Shape1} className="absolute top-0 left-0 -z-10" />
          </span>{" "}
          hub for all your
        </span>{" "}
        <span className="relative">
          <span>business</span>
          <img
            src={Shape2}
            className="absolute -bottom-[40px] -left-[25px] -z-10"
          />
        </span>{" "}
        <span className="relative">
          <span>needs</span>
          <img
            src={Shape3}
            alt=""
            className="absolute top-2 -right-[20px] -z-10"
          />
        </span>
      </div>

      <div className="flex gap-3 justify-center mt-8">
        <PrimaryButton>Start now - it’s free</PrimaryButton>
        <Button className="bg-lightPrimary text-webPrimary border-0 ring-0">
          Schedule a demo
        </Button>
      </div>
    </BannerContainer>
  );
};

export default Banner;
